import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'HighlightLightboxPlayer',
})(({ breakpoints, zIndex, typography }) => ({
  container: {
    zIndex: zIndex.modal,
    position: 'relative',
    // fixes the mysterious MUI black line under the image
    display: 'flex',

    '& iframe': { width: '100%', height: '100%' },
  },
  backButtonOverlay: {
    zIndex: zIndex.tooltip,
    position: 'absolute',
    top: typography.pxToRem(20),
    left: typography.pxToRem(10),

    [breakpoints.up('sm')]: {
      top: typography.pxToRem(20),
      left: typography.pxToRem(20),
    },
    [breakpoints.up('md')]: {
      top: typography.pxToRem(44),
      left: typography.pxToRem(80),
    },
  },
  closeButton: {
    zIndex: zIndex.tooltip,
    position: 'absolute',
    top: typography.pxToRem(10),
    right: typography.pxToRem(10),
    backgroundColor: 'transparent !important',

    [breakpoints.up('sm')]: {
      top: typography.pxToRem(20),
      right: typography.pxToRem(20),
    },
    [breakpoints.up('md')]: {
      top: typography.pxToRem(22),
      right: typography.pxToRem(40),
    },
  },
  dialog: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: 'black',
    borderRadius: 0,
    margin: 0,
    maxHeight: 'none',
    maxWidth: 'none',
  },
  image: {
    maxWidth: '100vw',
    maxHeight: '100svh',
  },
}));

export default useStyles;
